module.exports = __webpack_public_path__ + "static/media/jb-ottamaan-naytteita.7601e62f.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/jb-ottamaan-naytteita.mp4
 ** module id = 454
 ** module chunks = 0
 **/